<template>
  <div id="taps-summary" class="overflow-x-auto mx-4 mb-5">
    <div v-if="isLoading" class="w-full flex justify-center items-center h-72">
      <pl-spinner/>
    </div>
    <div v-else>
      <div v-if="tapsData.length !== 0">
        <table class="table-auto min-w-full">
          <thead>
            <thead>
              <tr>
                <th class="text-left px-2 py-2 border-b bg-white text-blueGray-800 select-none">Turn Type</th>
                <th v-for="(data, index) in tapsData" :key="index" class="text-center px-3 py-2 border-b cursor-pointer hover:underline bg-white ">
                  <Popper
                    :append-to-body="true"
                    :prevent-default="true"
                    trigger="hover"
                    :options="{
                      placement: 'top',
                    }"
                    
                  >
                    <div class="popper bg-white rounded-md shadow-sm relative">
                      <div class="flex items-center space-x-2 px-3 py-2">
                        <div class="h-5 w-5 bg-green-dark rounded-full flex items-center justify-center">
                          <img src="/static/roundtable_icons/verbal_icon.svg" class="w-2.5 h-2.5"/>
                        </div>
                        <h6 class="text-blueGray-800 text-xs font-poppins">{{ data.live_discussion }}</h6>
                      </div>
                    </div>
                    <button @click="handleGoRT(data.live_discussion_id)" class="h-full items-center font-semibold hover:underline font-poppins text-blueGray-800" slot="reference">
                      RT {{ index + 1  }}
                    </button>
                  </Popper>
                </th>
              </tr>
            </thead>
          </thead>
          <tbody>
            <tr>
              <td class="border-b py-1.5 px-2 font-poppins font-light">New Idea</td>
              <td v-for="(data, index) in tapsData" :key="index" class="text-left px-3 py-2 border-b bg-white">
                <div class="flex justify-center items-center">
                  <div 
                    class="w-8 h-8 flex items-center text-white justify-center select-none text-base font-poppins font-semibold rounded"
                    :class="{
                      'bg-blueGray-300': data.new_idea === 0,
                      'bg-primary bg-opacity-20': data.new_idea === 1,
                      'bg-primary bg-opacity-40': data.new_idea === 2,
                      'bg-primary bg-opacity-60': data.new_idea === 3,
                      'bg-primary bg-opacity-80': data.new_idea === 4,
                      'bg-primary': data.new_idea > 4,
                    }"
                  >
                    <span>{{ data.new_idea === 0 ? '-' : data.new_idea }}</span>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td class="border-b py-1.5 px-2 font-poppins font-light">Build On</td>
              <td v-for="(data, index) in tapsData" :key="index" class="text-left px-3 py-2 border-b bg-white">
                <div class="flex justify-center items-center">
                  <div 
                    class="w-8 h-8 flex items-center text-white justify-center select-none text-base font-poppins font-semibold rounded"
                    :class="{
                      'bg-gray-300': data.build_on === 0,
                      'bg-green-700 bg-opacity-20': data.build_on === 1,
                      'bg-green-700 bg-opacity-40': data.build_on === 2,
                      'bg-green-700 bg-opacity-60': data.build_on === 3,
                      'bg-green-700 bg-opacity-80': data.build_on === 4,
                      'bg-green-700': data.build_on > 4,
                    }"
                  >
                    <span>{{ data.build_on === 0 ? '-' : data.build_on }}</span>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td class="border-b py-1.5 px-2 font-poppins font-light">Challenge</td>
              <td v-for="(data, index) in tapsData" :key="index" class="text-left px-3 py-2 border-b bg-white">
                <div class="flex justify-center items-center">
                  <div 
                    class="w-8 h-8 flex items-center text-white justify-center select-none text-base font-poppins font-semibold rounded"
                    :class="{
                      'bg-gray-300': data.challenge === 0,
                      'bg-pinky bg-opacity-20': data.challenge === 1,
                      'bg-pinky bg-opacity-40': data.challenge === 2,
                      'bg-pinky bg-opacity-60': data.challenge === 3,
                      'bg-pinky bg-opacity-80': data.challenge === 4,
                      'bg-pinky': data.challenge > 4,
                    }"
                  >
                    <span>{{ data.challenge === 0 ? '-' : data.challenge }}</span>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td class="border-b py-1.5 px-2 font-poppins font-light">Question</td>
              <td v-for="(data, index) in tapsData" :key="index" class="text-left px-3 py-2 border-b bg-white">
                <div class="flex justify-center items-center">
                  <div 
                    class="w-8 h-8 flex items-center text-white justify-center select-none text-base font-poppins font-semibold rounded"
                    :class="{
                      'bg-gray-300': data.question === 0,
                      'bg-blueGray-300': data.question === 1,
                      'bg-blueGray-400': data.question === 2,
                      'bg-blueGray-500': data.question === 3,
                      'bg-blueGray-600': data.question === 4,
                      'bg-blueGray-800': data.question > 4,
                    }"
                  >
                    <span>{{ data.question === 0 ? '-' : data.question }}</span>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td class="border-b py-1.5 px-2 font-poppins font-light">By Teacher</td>
              <td v-for="(data, index) in tapsData" :key="index" class="text-left px-3 py-2 border-b bg-white">
                <div class="flex justify-center items-center">
                  <div 
                    class="w-8 h-8 flex items-center text-white justify-center select-none text-base font-poppins font-semibold rounded"
                    :class="{
                      'bg-gray-300': data.hand_raise === 0,
                      'bg-orange bg-opacity-20': data.hand_raise === 1,
                      'bg-orange bg-opacity-40': data.hand_raise === 2,
                      'bg-orange bg-opacity-60': data.hand_raise === 3,
                      'bg-orange bg-opacity-80': data.hand_raise === 4,
                      'bg-orange': data.hand_raise > 4,
                    }"
                  >
                    <span>{{ data.hand_raise === 0 ? '-' : data.hand_raise }}</span>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else class="w-full flex justify-center items-center h-72">
        <span class="font-poppins text-blueGray-800">No data to display</span>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue';
  import moment from 'moment';
  import { mapGetters } from 'vuex';
  import getLiveRoundtableEngagement from 'services/courses/getLiveRoundtableEngagement';
  import getMyLiveRoundtableEngagement from 'services/courses/getMyLiveRoundtableEngagement';
  import Popper from 'vue-popperjs';
import { EventBus } from '../../../../../utils/event-bus';

  Vue.directive('click-outside', {
    bind: function (el, binding, vnode) {
      el.clickOutsideEvent = function (event) {
        // here I check that click was outside the el and his children
        if (!(el == event.target || el.contains(event.target))) {
          // and if it did, call method provided in attribute value
          vnode.context[binding.expression](event);
        }
      };
      document.body.addEventListener('click', el.clickOutsideEvent);
    },
    unbind: function (el) {
      document.body.removeEventListener('click', el.clickOutsideEvent);
    },
  });
  export default Vue.extend({
    data() {
      return {
        tapsData: [],
        isLoading: false,
      };
    },
    components: {
      Popper,
    },
    computed: {
      ...mapGetters(['getProfile', 'hasTeacherPermissionsInCourse']),
    },
    watch: {
      '$route': async function () {
        this.isLoading = true;
        const { courseID, studentID } = this.$route.params;
        const { startDate, endDate } = this.$route.query;

        const dateStart =  startDate !== undefined ? moment.unix(startDate).format('YYYY/MM/DD') + ' ' + '00:00:00' : '';
        const dateEnd = endDate !== undefined ? moment.unix(endDate).format('YYYY/MM/DD') + ' ' + '23:59:59' : '';

        if (this.getProfile.id === studentID) {
          const result = await getMyLiveRoundtableEngagement(courseID, studentID, dateStart, dateEnd);
          this.tapsData = result;
          this.isLoading = false;
          return;
        }

        const result = await getLiveRoundtableEngagement(courseID, studentID, dateStart, dateEnd);
        this.tapsData = result;
        this.isLoading = false;
      }
    },
    methods: {
      handleGoRT: function(roundtable_id) {
        if (this.getProfile.is_paid === false) {
          return;
        }
        EventBus.$emit('handleChangeReportsTab', 'course.student-reports.discussion', roundtable_id);
      },
    },
    mounted: async function () {
      this.isLoading = true;
      const { courseID, studentID } = this.$route.params;
      const { startDate, endDate } = this.$route.query;

      const dateStart =  startDate !== undefined ? moment.unix(startDate).format('YYYY/MM/DD') + ' ' + '00:00:00' : '';
      const dateEnd = endDate !== undefined ? moment.unix(endDate).format('YYYY/MM/DD') + ' ' + '23:59:59' : '';

      if (this.getProfile.id === studentID) {
        const result = await getMyLiveRoundtableEngagement(courseID, studentID, dateStart, dateEnd);
        this.tapsData = result;
        this.isLoading = false;
        return;
      }

      if (this.getProfile.is_paid === true) {
        const result = await getLiveRoundtableEngagement(courseID, studentID, dateStart, dateEnd);
        this.tapsData = result;
      }

      if (!this.getProfile.is_paid) {
        this.tapsData = [{
          average_absolute_class_current_speakers: 0.13333333333333333,
          average_class_current_speakers:  "00h 00m 08s",
          build_on: 3,
          challenge: 1,
          hand_raise: 2,
          live_discussion: "Sample Verbal RoundTable",
          live_discussion_created_date: "2024-05-20T08:50:27.881Z",
          live_discussion_id: "77a5c521-ec05-4d0b-a514-04407b7adc97",
          new_idea: 4,
          question: 4,
          time_absolute_as_current_speaker: 0.14556666666666668,
          time_spent_as_current_speaker: "00h 00m 08s",
        },
        {
          average_absolute_class_current_speakers: 0.13333333333333333,
          average_class_current_speakers:  "00h 00m 08s",
          build_on: 6,
          challenge: 2,
          hand_raise: 4,
          live_discussion: "Diplomatic Negotiations and Security Concerns: U.S.-Russia Talks on Ukraine Conflict",
          live_discussion_created_date: "2024-05-20T08:50:27.881Z",
          live_discussion_id: "77a5c521-ec05-4d0b-a514-04407b7adc97",
          new_idea: 2,
          question: 1,
          time_absolute_as_current_speaker: 0.14556666666666668,
          time_spent_as_current_speaker: "00h 00m 08s",
        },
        {
          average_absolute_class_current_speakers: 0.13333333333333333,
          average_class_current_speakers:  "00h 00m 08s",
          build_on: 3,
          challenge: 3,
          hand_raise: 5,
          live_discussion: "World War I: Unprecedented Carnage and the Fall of Empires",
          live_discussion_created_date: "2024-05-20T08:50:27.881Z",
          live_discussion_id: "77a5c521-ec05-4d0b-a514-04407b7adc97",
          new_idea: 8,
          question: 1,
          time_absolute_as_current_speaker: 0.14556666666666668,
          time_spent_as_current_speaker: "00h 00m 08s",
        }];
      }
      this.isLoading = false;
    },
  });
</script>



// WEBPACK FOOTER //
// TapsSummary.vue?565cd504